import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import themeV2 from './theme/themeV2';

/**
 * Mounts the V2 design language for its children. Nested inside the app's
 * existing global ThemeProvider — children get themeV2 via context while the
 * rest of the app (anything outside this provider) keeps the legacy theme.
 *
 * `.v2-scope` is reserved for any future v2-only global CSS.
 */
const ThemeProviderV2 = ({ children }) => {
  return (
    <ThemeProvider theme={themeV2}>
      <Box
        className="v2-scope"
        sx={{
          backgroundColor: 'background.default',
          color: 'text.primary',
          fontFamily: themeV2.typography.fontFamily,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          minHeight: '100vh'
        }}
      >
        {children}
      </Box>
    </ThemeProvider>
  );
};

export default ThemeProviderV2;
